module.exports = __webpack_public_path__ + "static/img/12.b4be95a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/12.png
// module id = HCrJ
// module chunks = 0